<template>
  <v-row no-gutters>
    <v-col cols="12" md="12" class="pa-2">
      <v-card v-if="!hideControl">
        <v-card-title>
          <v-row no-gutters>
            <v-col cols="12" md="2" >
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                v-model="fromMenu"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDateValue"
                    label="From Date"
                    prepend-icon="event"
                    hide-details
                    readonly
                    v-on="on"
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="fromDate" @input="fromMenu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                v-model="toMenu"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDateValue"
                    label="To Date"
                    prepend-icon="event"
                    hide-details
                    readonly
                    v-on="on"
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="toDate" @input="toMenu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="10" md="2">
              <v-autocomplete
                prepend-icon="perm_contact_calendar"
                :items="onlineshoppingList"
                v-model="onlineshopping"
                label="Onlineshopping"
                item-text="name"
                return-object
                hide-details
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="pl-2">
              <v-btn fab depressed small color="primary" @click="search">
                <v-icon>search</v-icon>
              </v-btn>

              <v-btn depressed fab small class="mx-1" color="primary" outlined>
                <v-icon>help</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-col>
    <!-- <v-col cols="12" class="pa-2 pt-0">
      <v-card>
        <v-card-title class="pa-0">
          <v-row no-gutters>
            <v-col cols="12" md="4" class="py-4 px-3">OS To Paid Report</v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-col> -->
    <v-col
      cols="12"
      md="12"
      class="px-2 text-center"
      v-if="advanceReportData.collectPaymentList.length == 0"
    >No data available</v-col>
    <v-col cols="12" class="pa-2 pt-0" v-else>
      <v-card>
        <v-card-text>
          <v-data-table
            :items="advanceReportData.collectPaymentList"
            hide-default-footer
            :headers="statementHeader"
            :items-per-page="-1"
            :mobile-breakpoint="NaN"
            class="elevation-0"
            height="70vh"
          >
            <template v-slot:header.checked="{ items }">
              <v-checkbox
                @change="$refs.btnSelectAll.click()"
                v-model="selectedAll"
                hide-details
                class="ma-0"
              />
            </template>
            <!-- itemId: "",
              date: "",
              deliveryCost: data.totalDeliveryCost,
              paid: data.totalPaid,
              itemValue: data.totalItemValue,
            balance: data.totalBalance-->
            <template v-slot:body="{ items }">
              <input type="button" ref="btnSelectAll" @click="someSelect(items)" hidden />
              <tbody>
                <tr v-for="item in items" :key="item.itemId">
                  <template>
                    <td>
                      <v-checkbox
                        v-if="item.itemId != ''"
                        class="ma-0"
                        v-model="item.checked"
                        @change="itemChange(item.checked)"
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td>{{ item.itemId }}</td>
                    <td>{{ item.date }}</td>
                    <td>{{ item.modifiedAdvanceDate }}</td>
                    <td>{{ item.osName }}</td>
                    <td>{{ item.branchName}}</td>
                    <td>{{ item.itemValue | defaultPaymentFormat}}</td>
                    <td>{{ item.deliveryCost | defaultPaymentFormat}}</td>

                    <td v-if="item.paid<0" class="red--text">{{ item.paid | defaultPaymentFormat}}</td>
                    <td v-else>{{ item.paid | defaultPaymentFormat}}</td>

                    <td
                      v-if="item.advancePaid<0"
                      class="red--text"
                    >{{ item.advancePaid | defaultPaymentFormat}}</td>
                    <td v-else>{{ item.advancePaid | defaultPaymentFormat}}</td>

                    <td
                      v-if="item.customerBalance<0"
                      style="color: red !important;"
                    >{{ item.customerBalance | defaultPaymentFormat}}</td>
                    <td v-else>{{ item.customerBalance | defaultPaymentFormat}}</td>

                    <td
                      v-if="item.balance<0"
                      style="color: red !important;"
                    >{{ item.balance | defaultPaymentFormat}}</td>
                    <td v-else>{{ item.balance | defaultPaymentFormat}}</td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <!-- <template v-slot:item.itemValue="{ item }">
              <div>{{ item.itemValue | defaultPaymentFormat}}</div>
            </template>
            <template v-slot:item.deliveryCost="{ item }">
              <div>{{ item.deliveryCost | defaultPaymentFormat}}</div>
            </template>
            <template v-slot:item.balance="{ item }">
              <div
                v-if="item.balance<0"
                style="color: red;"
              >{{ item.balance | defaultPaymentFormat}}</div>
              <div v-else>{{ item.balance | defaultPaymentFormat}}</div>
            </template>
            <template v-slot:item.paid="{ item }">
              <div v-if="item.paid<0" style="color: red;">{{ item.paid | defaultPaymentFormat}}</div>
              <div v-else>{{ item.paid | defaultPaymentFormat}}</div>
          </template>-->

          <v-footer v-if="selectedItem.length>0" >
            <v-row no-gutters>
              <v-col cols="3">
                <v-label>Total Payment :</v-label>
                <v-chip  class="ma-1" color="cyan" outlined label>{{totalPayment}}</v-chip>
              </v-col>
              <v-col cols="9">
                <v-label>Selected Id :</v-label>
                <v-chip
                  @click:close="item.checked = false"
                  v-for="item in selectedItem"
                  v-model="item.checked"
                  :key="item.itemId"
                  class="ma-1"
                  color="cyan"
                  outlined
                  label
                  close
                >{{item.itemId}}</v-chip>
              </v-col>
              <v-col cols="12">
                <v-btn class="ma-1" color="primary" @click="acceptPayment">
                  <v-icon>add</v-icon>Accept
                </v-btn>
                <v-btn class="ma-1" color="error" @click="deletePayment">
                  <v-icon>delete</v-icon>Remove
                </v-btn>
              </v-col>
            </v-row>
          </v-footer>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import advanceReportService from "../service/AdvanceReportService";
import onlineshoppingService from "../service/OnlineshoppingService";

export default {
  mounted: function () {
    let itemId = this.$route.query.itemId;
    if (itemId != null) {
      this.hideControl = true;
      this.advancePaymentById(itemId);
    }
    this.getAllOnlineshopping();
  },
  data() {
    return {
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: new Date().toISOString().substr(0, 10),
      advanceReportData: {
        collectPaymentList: [],
      },
      onlineshoppingList: [],
      datePickerType: "date",
      onlineshopping: {},
      dateType: "date",
      fromMenu: false,
      toMenu: false,
      statementHeader: [
        {
          text: "",
          value: "checked",
          sortable: false,
          filterable: true,
        },
        { text: "Item Id", value: "itemId" },
        { text: "Date", value: "date" },
        { text: "Adv Modified", value: "modifiedAdvanceDate" },
        { text: "Os Name", value: "osName" },
        { text: "Branch", value: "branchName" },
        { text: "Item Value", value: "itemValue" },
        { text: "Delivery Cost", value: "deliveryCost" },
        { text: "Paid", value: "paid" },
        { text: "AdvancePaid", value: "advancePaid" },
        { text: "Customer Balance", value: "customerBalance" },
        { text: "Balance", value: "balance" },
      ],
      selectedAll: false,
      hideControl: false,
    };
  },
  methods: {
    search: function () {
      let itemId = this.$route.query.itemId;
      if (itemId != null) {
        this.hideControl = true;
        this.advancePaymentById(itemId);
      }

      advanceReportService
        .getAdvanceReportList(
          this.fromDateValue,
          this.toDateValue,
          this.onlineshopping.osId
        )
        .then((data) => {
          if (data.collectPaymentList.length != 0) {
            this.advanceReportData = data;
            this.advanceReportData.collectPaymentList.push({
              itemId: "",
              date: "",
              deliveryCost: data.totalDeliveryCost,
              paid: data.totalPaid,
              advancePaid: data.totalAdvancePaid,
              itemValue: data.totalItemValue,
              balance: data.totalBalance,
            });
          } else {
            this.advanceReportData = {
              collectPaymentList: [],
            };
          }
        });
    },
    getAllOnlineshopping: function () {
      onlineshoppingService.getAllOnlineshopping().then((response) => {
        this.onlineshoppingList.splice(0, this.onlineshoppingList.length);
        this.onlineshoppingList.push({ osId: 0, name: "All" });
        this.onlineshoppingList.push(...response);
        this.onlineshopping = this.onlineshoppingList[0];
      });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.dateType == "date") {
        // const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      } else if (this.dateType == "month") {
        // const [year, month, day] = date.split("-");
        return `${month}-${year}`;
      } else {
        // const [year, month, day] = date.split("-");
        return `${year}`;
      }
    },
    formatDateUrl(date) {
      //if (!date) return null;
      if (this.dateType == "month") {
        const [month, year] = date.split("-");
        return `01-${month}-${year}`;
      } else if (this.dateType == "year") {
        const [year] = date.split("-");
        return `01-01-${year}`;
      }
      return date;
    },
    someSelect: function (items) {
      let select = this.selectedAll;
      items.forEach((v) => {
        if (v.itemId != "") this.$set(v, "checked", select);

        //v.checked = checked;
      });
    },
    acceptPayment: function () {
      this.actionPayment(true);
      this.selectedAll = false;
      this.advanceReportData.collectPaymentList.forEach(
        (v) => (v.checked = false)
      );
    },
    deletePayment: function () {
      this.actionPayment(false);
      this.selectedAll = false;
      this.advanceReportData.collectPaymentList.forEach(
        (v) => (v.checked = false)
      );
    },
    itemChange: function (checked) {
      if (!checked) {
        this.selectedAll = false;
      }
    },
    actionPayment: function (isPay = false) {
      let ids = [];
      this.selectedItem.forEach((v) => {
        ids.push(v.itemId);
      });

      advanceReportService.actionAdvancePayment(ids, isPay).then((data) => {
        this.$swal({
          title: "Success!",
          text: "Advance Paid " + (isPay ? "Added" : "Removed"),
          icon: "info",
        });
        this.search();
      });
    },
    advancePaymentById: function (itemId) {
      advanceReportService.getAdvanceReportById(itemId).then((data) => {
        if (data.collectPaymentList.length != 0) {
          this.advanceReportData = data;
          this.advanceReportData.collectPaymentList.push({
            itemId: "",
            date: "",
            deliveryCost: data.totalDeliveryCost,
            paid: data.totalPaid,
            advancePaid: data.totalAdvancePaid,
            itemValue: data.totalItemValue,
            balance: data.totalBalance,
          });
        }
      });
    },
  },
  computed: {
    toDateValue() {
      var toDatetemp = "";
      toDatetemp = this.formatDate(this.toDate);
      return toDatetemp;
    },
    fromDateValue() {
      var fromDatetemp = "";
      fromDatetemp = this.formatDate(this.fromDate);
      return fromDatetemp;
    },
    selectedItem: function () {
      var item = this.advanceReportData.collectPaymentList.filter((v) => {
        if ((v.checked && v.balance < 0) || (v.checked && v.advancePaid < 0))
          return true;
        return false;
      });
      return item;
    },
    totalPayment: function () {
      let total = 0;
      this.selectedItem.forEach((v) => {
        total += Math.abs(v.balance);
      });
      return total;
    },
  },
};
</script>
<style scoped>
</style>